import classNames from 'classnames';
import { forwardRef } from 'react';
import { ContactDetailRows } from '../contact_detail_rows';
const detailsContainerCss = "d1yv8r5w";
const DetailsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(detailsContainerCss, props.className)} />;
});
export const AttendeeDetailsInline = ({
  resolved,
  canEditEmail,
  openEditEmailModal,
  paymentInfo,
  paymentLink
}) => <DetailsContainer data-testid="attendee-details-inline">
    <ContactDetailRows email={resolved.email} phoneNumber={resolved.phone} timezone={resolved.timezone} paymentInfo={paymentInfo} paymentLink={paymentLink} canEditEmail={canEditEmail} openEditEmailModal={openEditEmailModal} />
  </DetailsContainer>;

require("./attendee_details_inline.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./attendee_details_inline.js");